import { useEffect, useState } from 'react';

export function useCountdown(totalSeconds, startedAt = Date.now()) {
  const [remaining, setRemaining] = useState(() => computeRemaining(totalSeconds, startedAt));

  useEffect(() => {
    setRemaining(computeRemaining(totalSeconds, startedAt));
    if (!totalSeconds || process.env.JEST_WORKER_ID) {
      return undefined;
    }
    const timer = window.setInterval(() => {
      setRemaining(computeRemaining(totalSeconds, startedAt));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [startedAt, totalSeconds]);

  return remaining;
}

function computeRemaining(totalSeconds, startedAt) {
  const elapsed = Math.floor((Date.now() - Number(startedAt || Date.now())) / 1000);
  return Math.max(0, Number(totalSeconds || 0) - elapsed);
}
